import {z} from '@hono/zod-openapi';

import {amount} from './amount';

export const InventoryValueMonthSchema = z
  .object({
    month: z.string(),
    warehouseId: z.string(),
    branchId: z.string().nullable(),
    // NULL when a contributing movement is unpriced - unknown, not zero. Built on the
    // shared `amount` helper so coercion cannot turn null or '' into 0.
    purchaseValue: amount.nullable(),
  })
  .openapi('InventoryValueMonth');

export type InventoryValueMonth = z.infer<typeof InventoryValueMonthSchema>;
